var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.mainLoading)?_c('Loading'):(_vm.isLoggedIn)?_c('Admin'):_c('Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }